import { useState } from "react";
import DataModule from "@/components/DataModule";
import OnboardingWizard from "@/components/OnboardingWizard";
import { MODULES } from "@/config/modules";
import { useTenant } from "@/context/TenantContext";

export default function Sites() {
  const { company } = useTenant();
  const [wizard, setWizard] = useState(false);
  const [reload, setReload] = useState(0);
  return (
    <DataModule module={MODULES.sites} currency={company?.currency || "EUR"}
      onNewClick={() => setWizard(true)} newLabel="Add New Site" reloadKey={reload}>
      <OnboardingWizard open={wizard} mode="site"
        onClose={() => setWizard(false)}
        onComplete={() => { setWizard(false); setReload((r) => r + 1); }} />
    </DataModule>
  );
}
